import {getHasFreeCancellation} from '@daedalus/core/src/offer/business/offers'
import {SapiOfferWithChargeablePrices} from '@daedalus/core/src/offer/business/offersMapping'

export const getSearchOfferContext = (offer: SapiOfferWithChargeablePrices) => {
  return {
    offerId: offer.id,
    roomName: offer.roomName,
    meals: offer.package.amenities,
    displayPricePerRoomPerNight: offer.nightlyRate,
    offerTags: offer.tags,
    availableRooms: offer.availableRooms,
    canPayLater: offer.package.canPayLater,
    hasFreeCancellation: getHasFreeCancellation(offer),
    isAnchorPriceOffer: offer.tags?.includes('anchor_price'),
    isCheapest: offer.tags?.includes('cheapest'),
    isSplitBooking: false,
    isTopOffer: offer.tags?.includes('top_offer'),
    providerCode: offer.providerCode,
    cancellationPenalties: offer.cancellationPenalties,
    bookURI: offer.url,
    cug: offer.accessTier,
    proxyProviderCode: offer.intermediaryProvider
  }
}
